/* Tecidos Minimal — sections/tecidos-minimal.liquid
   Delegação de eventos no document: funciona mesmo se a seção for re-renderizada
   pelo editor de temas (sem <script> inline). */
(function () {
  if (window.__tecidosMinimal) return;
  window.__tecidosMinimal = true;

  function selectFabric(root, slug, scroll) {
    var panel = root.querySelector('[data-tm-panel="' + slug + '"]');
    if (!panel) return false;
    root.querySelectorAll('[data-tm-panel]').forEach(function (p) { p.hidden = p !== panel; });
    root.querySelectorAll('[data-tm-tab]').forEach(function (t) {
      var on = t.getAttribute('data-tm-tab') === slug;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      if (on && scroll) t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    });
    var carousel = panel.querySelector('[data-tm-carousel]');
    if (carousel) goTo(carousel, 0);
    return true;
  }

  function goTo(carousel, index) {
    var slides = carousel.querySelectorAll('[data-tm-slide]');
    if (!slides.length) return;
    index = Math.max(0, Math.min(index, slides.length - 1));
    slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
    carousel.setAttribute('data-tm-index', index);
    var prev = carousel.querySelector('[data-tm-prev]');
    var next = carousel.querySelector('[data-tm-next]');
    if (prev) prev.disabled = index === 0;
    if (next) next.disabled = index === slides.length - 1;
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-tm-tab]');
    if (tab) {
      var root = tab.closest('[data-tm]');
      var slug = tab.getAttribute('data-tm-tab');
      if (root && selectFabric(root, slug, true) && history.replaceState) {
        history.replaceState(null, '', '#' + slug);
      }
      return;
    }
    var arrow = e.target.closest('[data-tm-prev], [data-tm-next]');
    if (arrow) {
      var carousel = arrow.closest('[data-tm-carousel]');
      var current = parseInt(carousel.getAttribute('data-tm-index') || '0', 10);
      goTo(carousel, current + (arrow.hasAttribute('data-tm-next') ? 1 : -1));
    }
  });

  /* Setas do teclado entre os tecidos (padrão de tabs acessíveis) */
  document.addEventListener('keydown', function (e) {
    var tab = e.target.closest && e.target.closest('[data-tm-tab]');
    if (!tab || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
    var tabs = Array.prototype.slice.call(tab.closest('[data-tm]').querySelectorAll('[data-tm-tab]'));
    var i = tabs.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : -1);
    if (i < 0 || i >= tabs.length) return;
    e.preventDefault();
    tabs[i].focus();
    tabs[i].click();
  });

  /* Link direto: /pages/tecidos#linho abre o tecido Linho */
  function fromHash() {
    var slug = decodeURIComponent((location.hash || '').slice(1));
    if (!slug) return;
    document.querySelectorAll('[data-tm]').forEach(function (root) {
      if (selectFabric(root, slug, true)) {
        root.querySelector('.tm-selector').scrollIntoView({ block: 'start' });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fromHash);
  else fromHash();
  window.addEventListener('hashchange', fromHash);

  /* ============================================================
     Card de produto (snippets/tecidos-card.liquid): cor + tamanho,
     tabela de medidas (Sizebay) e adicionar ao carrinho.
     Mesma lógica da vitrine compre-3-leve-4 (assets/compre-3-leve-4.js).
     Fail-safe: card com JSON inválido fica como link para a PDP.
     ============================================================ */
  var COLOR_RE = /^cor$|^color$/i;
  var SIZE_RE = /tamanho|size/i;
  var PIX = 0, PARCELAS = 1;
  function brl(cents) {
    return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  var STORE_SWATCHES = {};

  function Card(el) {
    this.el = el;
    this.p = JSON.parse(el.querySelector('[data-tm-product]').textContent);
    this.opts = el.querySelector('[data-tm-opts]');
    this.msg = el.querySelector('[data-tm-msg]');
    this.btn = el.querySelector('[data-tm-add]');
    this.btnLabel = this.btn.textContent.trim();
    this.priceEl = el.querySelector('[data-tm-price]');
    this.img = el.querySelector('.tm-card__img');
    this.chartBtn = el.querySelector('[data-tm-chart]');
    var names = this.p.options || [];
    this.colorIdx = names.findIndex(function (n) { return COLOR_RE.test(n); });
    this.sizeIdx = names.findIndex(function (n) { return SIZE_RE.test(n); });
    // Pré-seleciona a 1ª variante disponível, MENOS o tamanho: o cliente escolhe.
    var first = this.p.variants.find(function (v) { return v.available; }) || this.p.variants[0];
    this.sel = first ? first.options.slice() : [];
    if (this.sizeIdx >= 0 && this.values(this.sizeIdx).length > 1) this.sel[this.sizeIdx] = null;
    this.btn.setAttribute('role', 'button');
    // A 1ª cor com estoque pode não ser a da foto principal: mostra a foto da cor selecionada.
    var startImg = this.colorIdx >= 0 && this.imageFor(this.sel[this.colorIdx]);
    var base = function (u) { return String(u || '').split('?')[0].split('/').pop(); };
    if (this.img && startImg && base(startImg) !== base(this.img.getAttribute('src'))) {
      this.img.removeAttribute('srcset');
      this.img.src = startImg;
    }
    this.render();
    this.initChart();
  }
  Card.prototype.values = function (i) {
    var seen = {}, out = [];
    this.p.variants.forEach(function (v) {
      var val = v.options[i];
      if (!(val in seen)) { seen[val] = true; out.push(val); }
    });
    return out;
  };
  // Um valor tem estoque se existe variante disponível com ele + as OUTRAS opções escolhidas.
  Card.prototype.available = function (i, val) {
    var sel = this.sel;
    return this.p.variants.some(function (v) {
      if (!v.available || v.options[i] !== val) return false;
      return sel.every(function (s, j) { return j === i || s == null || v.options[j] === s; });
    });
  };
  Card.prototype.variant = function () {
    var sel = this.sel;
    if (sel.some(function (s) { return s == null; })) return null;
    return this.p.variants.find(function (v) {
      return sel.every(function (s, j) { return v.options[j] === s; });
    }) || null;
  };
  Card.prototype.imageFor = function (color) {
    var ci = this.colorIdx;
    var v = this.p.variants.find(function (x) { return x.options[ci] === color && x.featured_image; });
    return v ? v.featured_image : '';
  };
  Card.prototype.render = function () {
    var self = this;
    this.opts.innerHTML = (this.p.options || []).map(function (name, i) {
      var vals = self.values(i);
      if (vals.length <= 1) return '';
      var isColor = i === self.colorIdx;
      var btns = vals.map(function (val) {
        var ok = self.available(i, val);
        var on = self.sel[i] === val;
        var cls = (isColor ? 'tm-sw' : 'tm-opt') + (on ? ' is-on' : '') + (ok ? '' : ' is-out');
        var style = '';
        if (isColor) {
          var hex = (self.p.swatches || {})[val] || STORE_SWATCHES[val];
          var img = self.imageFor(val);
          style = hex ? ' style="--sw:' + esc(hex) + '"' : (img ? ' style="--sw-img:url(\'' + esc(img) + '\')"' : '');
        }
        return '<button type="button" class="' + cls + '"' + style + ' data-i="' + i + '" data-v="' + esc(val) +
          '" aria-pressed="' + on + '" title="' + esc(val) + '" aria-label="' + esc(name + ': ' + val + (ok ? '' : ' (esgotado)')) + '">' +
          (isColor ? '' : esc(val)) + '</button>';
      }).join('');
      var label = isColor
        ? '<span class="tm-card__rowname">' + esc(name) + ': <b>' + esc(self.sel[i] || '') + '</b></span>'
        : '<span class="tm-card__rowname">' + esc(name) + '</span>';
      return '<div class="tm-card__row' + (isColor ? ' tm-card__row--color' : '') + '" role="group" aria-label="' + esc(name) + '">' +
        label + '<div class="tm-card__btns">' + btns + '</div></div>';
    }).join('');
    this.update();
  };
  Card.prototype.update = function () {
    var v = this.variant();
    var ci = this.colorIdx, cor = this.sel[ci];
    var ref = v || this.p.variants.find(function (x) { return ci < 0 || x.options[ci] === cor; });
    if (ref && this.priceEl) {
      var cmp = ref.compare_at_price > ref.price ? '<s class="tm-price__cmp">' + brl(ref.compare_at_price) + '</s>' : '';
      var pix = Math.round(ref.price * (100 - PIX) / 100);
      var inst = PARCELAS > 1 ? '<span class="tm-price__inst">ou ' + PARCELAS + 'x de ' + brl(Math.floor(ref.price / PARCELAS)) + ' sem juros</span>' : '';
      this.priceEl.innerHTML = cmp + '<span class="tm-price__pix"><b>' + brl(pix) + '</b> no pix</span>' + inst;
    }
    this.msg.textContent = '';
    this.btn.classList.remove('is-added');
    var temNaCor = this.p.variants.some(function (x) { return x.available && (ci < 0 || cor == null || x.options[ci] === cor); });
    var out = (v && !v.available) || !temNaCor;
    this.btn.classList.toggle('is-disabled', out);
    this.btn.setAttribute('aria-disabled', out ? 'true' : 'false');
    this.btn.textContent = out ? 'Esgotado' : this.btnLabel;
  };
  Card.prototype.pick = function (i, val) {
    var self = this;
    this.sel[i] = val;
    if (i === this.colorIdx) {
      // ao trocar de cor, solta o tamanho se ele não existe na cor nova
      this.sel.forEach(function (s, j) {
        if (j !== i && s != null && !self.available(j, s)) {
          self.sel[j] = j === self.sizeIdx ? null : self.values(j).find(function (x) { return self.available(j, x); }) || s;
        }
      });
      var img = this.imageFor(val);
      if (this.img && img) {
        this.img.removeAttribute('srcset');
        this.img.src = img;
      }
    }
    this.render();
  };
  Card.prototype.add = function () {
    var self = this;
    if (this.btn.classList.contains('is-disabled') || this.busy) return;
    var missing = (this.p.options || []).filter(function (n, i) { return self.sel[i] == null; });
    if (missing.length) {
      this.msg.textContent = 'Escolha o ' + missing[0].toLowerCase();
      this.el.classList.add('tm-card--shake');
      setTimeout(function () { self.el.classList.remove('tm-card--shake'); }, 400);
      return;
    }
    var v = this.variant();
    if (!v || !v.available) return;
    this.busy = true;
    this.btn.textContent = 'Adicionando…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: v.id, quantity: 1 }],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function (data) {
        self.busy = false;
        self.btn.classList.add('is-added');
        self.btn.textContent = '✓ Adicionado';
        document.dispatchEvent(new CustomEvent('cart:updated'));
        openCart(data);
        setTimeout(function () { self.update(); }, 1800);
      })
      .catch(function (err) {
        self.busy = false;
        self.btn.textContent = self.btnLabel;
        self.msg.textContent = (err && err.description) || 'Não foi possível adicionar. Tente de novo.';
      });
  };

  // Abre o carrinho lateral com o item novo (mesmo fluxo do botão da PDP: renderContents).
  // Se o tema não tiver a gaveta, atualiza o ícone e mantém o "✓ Adicionado".
  function openCart(data) {
    var drawer = document.querySelector('cart-drawer');
    try {
      if (drawer && typeof drawer.renderContents === 'function' && data && data.sections) {
        drawer.renderContents(data);
        return;
      }
    } catch (e) { /* cai no fallback */ }
    try {
      var html = data && data.sections && data.sections['cart-icon-bubble'];
      var bubble = document.getElementById('cart-icon-bubble');
      var src = html && new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
      if (bubble && src) bubble.innerHTML = src.innerHTML;
    } catch (e) { /* o add já foi feito */ }
  }

  /* ---------- tabela de medidas (Sizebay) ---------- */
  // Mesmas chamadas da vitrine compre-3-leve-4 / PDP: sessão, id do produto na Sizebay pelo id
  // da Shopify e a tabela num iframe. Produto sem medidas na Sizebay → o botão não aparece.
  var SZB = 'https://vfr-v3-production.sizebay.technology';
  var szbSid = null, szbIds = {};
  function szbSession() {
    if (!szbSid) szbSid = fetch(SZB + '/api/me/session-id').then(function (r) { return r.text(); }).then(function (t) { return t.replace(/"/g, '').trim(); });
    return szbSid;
  }
  function szbProductId(pid) {
    if (!szbIds[pid]) {
      szbIds[pid] = szbSession().then(function (sid) {
        return fetch(SZB + '/plugin/my-product-id?sid=' + encodeURIComponent(sid) + '&permalink=' + encodeURIComponent('https://minimalclub.com.br/' + pid))
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (d) { return d && d.id && !d.accessory ? { id: d.id, sid: sid } : null; });
      }).catch(function () { return null; });
    }
    return szbIds[pid];
  }
  function openSizeTable(info, sizes) {
    var enc = '';
    try { enc = btoa(unescape(encodeURIComponent(JSON.stringify(sizes)))); } catch (e) { /* sem tamanhos */ }
    var url = 'https://measurements-table.sizebay.technology/?id=' + encodeURIComponent(info.id) + '&sid=' + encodeURIComponent(info.sid) +
      '&lang=br&tenantId=1269&sizes=' + enc + '&pageProductImg=false&hasRecommendation=&device=false';
    var ov = document.createElement('div');
    ov.className = 'tm-szb';
    ov.setAttribute('role', 'dialog');
    ov.setAttribute('aria-modal', 'true');
    ov.setAttribute('aria-label', 'Tabela de medidas');
    // A tabela da Sizebay tem o próprio X (avisa por postMessage "close"); fora dela, clique no fundo ou Esc.
    ov.innerHTML = '<div class="tm-szb__box"><iframe class="tm-szb__frame" title="Tabela de medidas" src="' + esc(url) + '"></iframe></div>';
    var close = function () {
      ov.remove();
      document.removeEventListener('keydown', onKey, true);
      window.removeEventListener('message', onMsg);
    };
    var onKey = function (e) { if (e.key === 'Escape') { e.stopPropagation(); close(); } };
    var onMsg = function (e) {
      if (/sizebay\.technology$/.test(e.origin) && String(e.data).indexOf('close') >= 0) close();
    };
    ov.addEventListener('click', function (e) { if (e.target === ov) close(); });
    document.addEventListener('keydown', onKey, true);
    window.addEventListener('message', onMsg);
    document.body.appendChild(ov);
  }
  Card.prototype.pid = function () {
    var ci = this.colorIdx, cor = this.sel[ci];
    var v = this.p.variants.find(function (x) { return x.pid && (ci < 0 || x.options[ci] === cor); }) || this.p.variants[0];
    return v && v.pid;
  };
  Card.prototype.initChart = function () {
    var self = this, pid = this.pid();
    if (!this.chartBtn || !pid) return;
    szbProductId(pid).then(function (info) { if (info && self.chartBtn.isConnected) self.chartBtn.hidden = false; });
  };
  Card.prototype.openChart = function () {
    var self = this, first = this.p.variants[0] && this.p.variants[0].pid;
    var sizes = this.sizeIdx >= 0 ? this.values(this.sizeIdx) : [];
    szbProductId(this.pid() || first).then(function (info) {
      return info || szbProductId(first);
    }).then(function (info) { if (info) openSizeTable(info, sizes); else window.location.href = self.btn.getAttribute('href'); });
  };

  var cards = new WeakMap();
  function initCards() {
    var root = document.querySelector('[data-tm]');
    if (!root) return;
    PIX = parseFloat(root.getAttribute('data-tm-pix')) || 0;
    PARCELAS = parseInt(root.getAttribute('data-tm-parcelas'), 10) || 1;
    var els = root.querySelectorAll('[data-tm-card]');
    [].forEach.call(els, function (el) {
      try {
        var sw = JSON.parse(el.querySelector('[data-tm-product]').textContent).swatches || {};
        Object.keys(sw).forEach(function (k) { if (sw[k] && !STORE_SWATCHES[k]) STORE_SWATCHES[k] = sw[k]; });
      } catch (e) { /* card inválido */ }
    });
    [].forEach.call(els, function (el) {
      if (cards.has(el)) return;
      try { cards.set(el, new Card(el)); el.classList.add('is-ready'); } catch (e) { /* fica o link pra PDP */ }
    });
  }
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[data-tm-card]');
    var card = el && cards.get(el);
    if (!card) return;
    var opt = e.target.closest('[data-i]');
    if (opt && card.opts.contains(opt)) {
      if (opt.classList.contains('is-out') && parseInt(opt.getAttribute('data-i'), 10) !== card.colorIdx) return;
      card.pick(parseInt(opt.getAttribute('data-i'), 10), opt.getAttribute('data-v'));
      return;
    }
    if (e.target.closest('[data-tm-chart]')) { card.openChart(); return; }
    if (e.target.closest('[data-tm-add]')) { e.preventDefault(); card.add(); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCards);
  else initCards();
  document.addEventListener('shopify:section:load', initCards);
})();
